import { z } from 'zod';
import { NumericalIdSchema } from './commonTypes';
export var AccountIdSchema = NumericalIdSchema;
export var AccountSchema = z.object({
    account_id: AccountIdSchema.optional(),
    id: AccountIdSchema,
    account_name: z.string(),
    creator_id: z.coerce.number(),
    status: z.coerce.number(),
    stripe_card_type: z.string().nullable(),
    stripe_last4: z.string().nullable(),
    stripe_product_tier: z.string().nullable(),
    stripe_product_interval: z.string().nullable(),
    stripe_product_quantity: z.coerce.number().nullable(),
    stripe_product_is_paused: z.coerce.boolean().nullable(),
    stripe_status: z.string().nullable(),
    stripe_trial_end: z.coerce.number().nullable(),
    timezone: z.string(),
    public_expectations: z.coerce.boolean(),
    privacy_setting: z.coerce.number(),
    onboarding_completed: z.coerce.boolean(),
    disable_memo: z.boolean().optional(),
    days_since_first_score: z.number(),
    add_time: z.string(),
    update_time: z.string(),
    logo: z.string().nullable()
});
